import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {  Row, Col } from 'reactstrap';
import {  reduxForm } from "redux-form";
// import CheckboxGroup from 'react-checkbox-group'
import Toast from './../../../config/toast'
import { VALIDATION, TYPE } from './../config'
import { getAdvertisers } from './../../applications/action'
import { updatePermission, getUserClients } from './../action'
import _ from 'lodash';

class PermissionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editPermission: false,
            checked: [],
            expanded: [],
            advertisersList: [],
            checkedClients: []
        }
        this.onChange = this.onChange.bind(this)
    }
    componentDidMount() {
        const { userId, applicationId, editUser, getAdvertisers, getUserClients } = this.props;
        console.log("userId ", editUser)
        getAdvertisers(applicationId)
        editUser && getUserClients({ userId, applicationId })

    }
    componentWillReceiveProps(nextProps) {
        if (this.props.advertisers !== nextProps.advertisers) {
            this.setState({ advertisersList: nextProps.advertisers })
        }
        if (this.props.userClients !== nextProps.userClients) {
            this.setState({
                checkedClients: _.uniq(_.map(_.map(nextProps.userClients, "client_id"), Number)),
                checked: _.uniq(_.map(_.map(nextProps.userClients, "client_id"), Number))
            })
        }
    }
    onSubmit(values) {
        const { userId,editUser, applicationId, updatePermission } = this.props;
        const { checked, checkedClients } = this.state;
        if (checked.length) {
            const data = {
                userId,
                applicationId,
            }
           
            if (editUser) {
                const newClients = _.differenceWith(checked, checkedClients, _.isEqual)
                const removedClients = _.differenceWith(checkedClients, checked, _.isEqual)
              
                newClients.length && (data.insertClient = newClients)
                removedClients.length && (data.deleteClient = removedClients)
            } else {
                data.insertClient = checked
            }
            console.log("data----->", data)
            updatePermission(data)
        } else {
            Toast(VALIDATION.EMPTY_CLIENT, TYPE.ERROR)
        }
    }
    onChange(id) {
        let checked = this.state.checked
        let find = checked.indexOf(id)

        if (find > -1) {
            checked.splice(find, 1)
        } else {
            checked.push(id)
        }

        this.setState({ checked })
    }

    render() {
        const { handleSubmit } = this.props;
        const { advertisersList, checked } = this.state;
        console.log("checked--->", checked)
       
        return (
            <form className="mt-3" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                <Row>
                    <Col>
                        {/* <CheckboxGroup name="clients"
                            value={checked}
                            onChange={checked => this.setState({ checked })}>
                            {(Checkbox) => (
                                <>
                                    <Row>
                                        {array.map((data) => {
                                            return <Col md="4">
                                                <label>
                                                    <Checkbox value={data.id}  /> {data.name}
                                                </label>
                                            </Col>
                                        })}
                                    </Row>
                                </>
                            )}
                        </CheckboxGroup> */}
                        <Row>
                            {advertisersList.map((data, index) => {
                                return <Col md="4">
                                    <label>
                                        <input type="checkbox"
                                            value={data.id}
                                            checked={checked.includes(data.id)}
                                            onChange={() => this.onChange(data.id)}
                                            selected={this.state.checked.includes(data.id)} /> {data.name}
                                    </label>
                                </Col>
                            })}
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <div className="modal-button">
                        <button type="submit" className="btn btn-primary btn-play">Submit</button>
                    </div>
                </Row>
            </form>
        );
    }
}

function validate(values) {
    const errors = {};

    return errors;
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getAdvertisers, updatePermission, getUserClients }, dispatch);
}

function mapStateToProps({ advertisers, userClients }) {
    return { advertisers, userClients };
}

export default reduxForm({
    validate,
    form: "PermissionForm"
})(connect(mapStateToProps, mapDispatchToProps)(PermissionForm));
